import { Attributes, DateUtils, Misc, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class Pipeline extends ModelBase {
    static typeName = "Pipeline";

    public pipelineId: number = 0;

    @Rules.StringLength(50)
    @Rules.Required()
    public pipelineName: string = "";

    @Attributes.Display("Fixed Rate?")
    public isFixedRate: boolean = false;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = null;

    @Attributes.Float()
    public capacityFunding: number = 0;

    @Attributes.Float()
    public externalFunding: number = 0;

    @Attributes.Float()
    public fundingRate: number = 0;

    @Attributes.Float()
    public fundingRateNACM: number = 0;

    // Client only properties / methods

    @Attributes.Display("Pipeline")
    @Attributes.DisplayMember()
    public get pipelineDisplay(): string {
        var display = this.pipelineName;
        if (this.startDate) {
            display += " - " + DateUtils.format(this.startDate, "yyyy/MM/dd");
        }
        return display;
    }

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
        rules.failWhen(c => !(c.capacityFunding + c.externalFunding == 1), "The sum of Capacity Funding and External Funding must equal 100%");
    }

    public toString(): string {
        if (this.isNew || !this.pipelineName) {
            return "New pipeline";
        } else {
            return this.pipelineName;
        }
    }
}